import * as React from 'react'
import { connect } from 'react-redux'
import { RootState } from 'pc/reducer'
import { KeyCode } from 'common/constants/keyCode'
import { styling } from 'common/utils'
import { DynamicCx } from 'common/types'
import OutsideClick from 'common/components/OutsideClick'
import {
  DetailSearchState,
  toggleDetailSearch,
  closeDetailSearch,
} from 'pc/components/Common/Header/ducks/gnb/detailSearch'
import * as s from './detailSearch.scss'

interface StateProps {
  detailSearch: DetailSearchState
}

interface DispatchProps {
  toggleDetailSearch: typeof toggleDetailSearch
  closeDetailSearch: typeof closeDetailSearch
}

interface State {
  baseQuery: string
  include: string
  matchExactly: string
  exclude: string[]
  usedExcluded: boolean
  overseasExcluded: boolean
}

interface OwnProps {
  onSearch?: Function
  cx?: DynamicCx
}

type Props = StateProps & DispatchProps & OwnProps

@styling(s)
class DetailSearch extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      baseQuery: '',
      include: '',
      matchExactly: '',
      exclude: [],
      usedExcluded: false,
      overseasExcluded: false,
    }
  }

  isExistBasicQuery() {
    const { baseQuery } = this.state
    if (!baseQuery || baseQuery.replace(' ', '') === '') {
      alert('기본 검색어를 입력해 주세요.')
      return false
    }
    return true
  }

  handleKeyDownDetailSearch = e => {
    if (e.keyCode === KeyCode.ENTER) {
      e.preventDefault()
      if (!this.isExistBasicQuery()) return

      const computedQuery = this.computeOverallQuery()
      this.props.onSearch({ keyword: computedQuery })
    }
  }

  handleClickDetailSearchButton = () => {
    this.props.toggleDetailSearch()
  }

  handleClickSearchButton = () => {
    if (!this.isExistBasicQuery()) return

    const computedQuery = this.computeOverallQuery()
    this.props.onSearch({ keyword: computedQuery })
  }

  handleClickExcludeOverseasCheckBox = e => {
    const checked = e.target.checked
    const indexOfOverseas = this.state.exclude.indexOf('해외')
    const excludeArray = this.state.exclude.slice()
    indexOfOverseas >= 0 || !checked
      ? excludeArray.splice(indexOfOverseas, 1)
      : excludeArray.splice(this.state.exclude.length, 0, '해외')
    this.setState({
      overseasExcluded: checked,
      exclude: excludeArray,
    })
  }

  handleClickExcludeUsedCheckBox = e => {
    const checked = e.target.checked
    const indexOfOverseas = this.state.exclude.indexOf('중고')
    const excludeArray = this.state.exclude.slice()
    indexOfOverseas >= 0 || !checked
      ? excludeArray.splice(indexOfOverseas, 1)
      : excludeArray.splice(this.state.exclude.length, 0, '중고')
    this.setState({
      usedExcluded: checked,
      exclude: excludeArray,
    })
  }

  handleCloseLayer = () => {
    this.props.closeDetailSearch()
  }

  handleDefaultInputChange = e => {
    const baseQuery = e.target.value
    if (baseQuery.match(/[+\-|]/)) {
      alert('+, -, | 는 입력하실 수 없습니다.')
      return
    }
    this.setState({
      baseQuery,
    })
  }

  handleIncludeInputChange = e => {
    const input = e.target.value
    if (input.match(/["\/|]/)) {
      alert('"/| 는 입력하실 수 없습니다.')
      return
    }
    this.setState({
      include: input,
    })
  }

  handleExactInputChange = e => {
    const input = e.target.value
    if (input.match(/["\/|]/)) {
      alert('"/| 는 입력하실 수 없습니다.')
      return
    }
    this.setState({
      matchExactly: input,
    })
  }

  handleExcludeInputChange = e => {
    const input = e.target.value
    let excludeArray = []
    if (input.match(/["\/|]/)) {
      alert('"/| 는 입력하실 수 없습니다.')
      return
    }
    if (input.length > 0) {
      excludeArray = input.split(',')
    }
    this.setState({
      exclude: excludeArray,
    })
  }

  handleInitialization = () => {
    this.setState({
      baseQuery: '',
      include: '',
      matchExactly: '',
      exclude: [],
      usedExcluded: false,
      overseasExcluded: false,
    })
  }

  computeOverallQuery = () => {
    const { include, matchExactly, exclude, baseQuery } = this.state
    const includeFormatted = include
      .split(',')
      .filter(str => str.trim().length > 0)
      .map(str => ` +${str.trim()}`)
      .join(' ')
    const matchExactlyFormatted = matchExactly
      .split(',')
      .filter(str => str.trim().length > 0)
      .map(str => ` "${str.trim()}"`)
      .join(' ')
    const excludeFormatted = exclude
      .filter(str => str.trim().length > 0)
      .map(str => ` -${str.trim()}`)
      .join(' ')

    return `${baseQuery} ${includeFormatted} ${matchExactlyFormatted} ${excludeFormatted}`
  }

  render() {
    const { detailSearch, cx } = this.props
    const { baseQuery, include, matchExactly, exclude, usedExcluded, overseasExcluded } = this.state

    return (
      <>
        <button
          type="button"
          className={cx('btn_detail', '@N=a:SNB.detailsearch')}
          onClick={this.handleClickDetailSearchButton}>
          <span className={cx('text')}>상세검색</span>
          {detailSearch.isOpen ? (
            <span className={cx('more', '@active')}>펼치기</span>
          ) : (
            <span className={cx('more')}>접기</span>
          )}
        </button>
        <OutsideClick onClickOutside={this.handleCloseLayer} isRendered={detailSearch.isOpen} stopPropagation={false}>
          <div
            className={cx('layer_detail', `${detailSearch.isOpen ? '@active' : ''}`)}
            onKeyDown={this.handleKeyDownDetailSearch}>
            <strong className={cx('title')}>상세검색</strong>
            <div className={cx('inner')}>
              <p className={cx('preview')}>{this.computeOverallQuery()}</p>
              <table className={cx('detail_input')} role="presentation">
                <colgroup>
                  <col style={{ width: 171 }} />
                  <col />
                </colgroup>
                <tbody>
                  <tr className={cx('search_box')}>
                    <th scope="row">
                      <label htmlFor="search_basis">
                        <strong>기본검색</strong>
                      </label>
                    </th>
                    <td>
                      <input
                        type="text"
                        id="lb_srh_basis"
                        className={cx('search_input')}
                        maxLength={50}
                        onChange={this.handleDefaultInputChange}
                        value={baseQuery}
                      />
                    </td>
                  </tr>
                  <tr className={cx('search_box')}>
                    <th scope="row">
                      <strong>상세검색</strong>
                    </th>
                    <td>
                      <p className={cx('desc')}>
                        <strong className={cx('bright')}>*</strong>
                        기본 검색의 결과 범위를 줄이고자 할 때 사용합니다.
                        <br />
                        여러개의 단어를 입력할 때는
                        <span className={cx('bright')}> 쉼표(, )</span>로 구분해서 입력하세요.
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">
                      <label htmlFor="lb_srh_include">결과내 재검색 단어 (+)</label>
                    </th>
                    <td>
                      <input
                        type="text"
                        id="lb_srh_include"
                        className={cx('search_input')}
                        maxLength={50}
                        onChange={this.handleIncludeInputChange}
                        value={include}
                      />
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">
                      <label htmlFor="lb_srh_exact">정확히 일치하는 문장 (“”)</label>
                    </th>
                    <td>
                      <input
                        type="text"
                        id="lb_srh_exact"
                        className={cx('search_input')}
                        maxLength={50}
                        onChange={this.handleExactInputChange}
                        value={matchExactly}
                      />
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">
                      <label htmlFor="lb_srh_exclude">제외하는 단어 (-)</label>
                    </th>
                    <td>
                      <input
                        type="text"
                        id="lb_srh_exclude"
                        className={cx('search_input')}
                        maxLength={50}
                        onChange={this.handleExcludeInputChange}
                        value={exclude.length > 0 ? exclude.join(',') : ''}
                      />
                      <ul className={cx('search_exclude')}>
                        <li className={cx('@N=a:sch*d.exabroad')}>
                          <input
                            type="checkbox"
                            id="lb_exclude1"
                            onClick={this.handleClickExcludeOverseasCheckBox}
                            checked={overseasExcluded}
                          />
                          <label htmlFor="lb_srh_exclude">해외상품 제외</label>
                        </li>
                        <li className={cx('@N=a:sch*d.exused')}>
                          <input
                            type="checkbox"
                            id="lb_exclude2"
                            onClick={this.handleClickExcludeUsedCheckBox}
                            checked={usedExcluded}
                          />
                          <label htmlFor="lb_srh_exclude">중고상품 제외</label>
                        </li>
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className={cx('info_or')}>
              <strong className={cx('bright')}>*</strong> 네이버쇼핑내에선 OR 검색어는 제공하지 않습니다.
            </p>
            <div className={cx('btn_area')}>
              <a
                href="https://help.naver.com/support/contents/contents.nhn?serviceNo=606&categoryNo=1911"
                target="_blank"
                className={cx('link_help', '@N=a:sch*d.help')}>
                도움말
              </a>
              <button
                type="button"
                className={cx('btn_refresh', '@N=a:sch*d.reset')}
                onClick={this.handleInitialization}>
                초기화
              </button>
              <button
                type="button"
                className={cx('btn_search', '@N=a:sch*d.search')}
                onClick={this.handleClickSearchButton}>
                검색
              </button>
              <button type="button" className={cx('btn_cancel', '@N=a:sch*d.close')} onClick={this.handleCloseLayer}>
                닫기
              </button>
            </div>
            <button type="button" className={cx('btn_close', '@N=a:sch*d.x')} onClick={this.handleCloseLayer}>
              상세검색 닫기
            </button>
          </div>
        </OutsideClick>
      </>
    )
  }
}

export default connect<StateProps, DispatchProps, OwnProps>(
  (state: RootState) => ({
    detailSearch: state.gnb.detailSearch,
  }),
  {
    toggleDetailSearch,
    closeDetailSearch,
  },
)(DetailSearch)
